//SoilTaxRate.ts =================================================

const sa: string[] = [];
//Soil type, Timber code, Timber cost, Crop code, Crop cost.
sa.push("AmB,3T,141,4C,110");
sa.push("ApB,3T,141,3C,161");
sa.push("ApC,3T,141,5C,60");
sa.push("Ca,2T,192,3C,161");
sa.push("CcB2,3T,141,6C,43");
sa.push("CcC2,3T,141,6C,43");
sa.push("CbB,3T,141,6C,43");
sa.push("CbC,3T,141,6C,43");
sa.push("CeB2,3T,141,6C,43");
sa.push("CeC2,4T,102,6C,43");
sa.push("CdB,3T,141,3C,161");
sa.push("CdC,3T,141,4C,110");
sa.push("CdD,3T,141,6C,43");
sa.push("CmB,3T,141,3C,161");
sa.push("Cn,1T,242,3C,161");
sa.push("CoB,4T,102,4C,110");
sa.push("CoC,4T,102,6C,43");
sa.push("DaB,3T,141,1C,378");
sa.push("DaC,3T,141,2C,255");
sa.push("DuB,3T,141,3C,161");
sa.push("EnB,4T,102,3C,161");
sa.push("EnC,4T,102,5C,60");
sa.push("EnD,4T,102,6C,43");
sa.push("GaB,3T,141,3C,161");
sa.push("GaC,3T,141,6C,43");
sa.push("GeB2,3T,141,6C,43");
sa.push("GeC2,3T,141,6C,43");
sa.push("GoD,4T,102,6C,43");
sa.push("GoF,4T,102,6C,43");
sa.push("HeB,3T,141,4C,110");
sa.push("HeC,3T,141,6C,43");
sa.push("HrB,3T,141,3C,161");
sa.push("HrC,3T,141,5C,60");
sa.push("HyB2,4T,102,6C,43");
sa.push("HyC2,4T,102,6C,43");
sa.push("HwB,3T,141,3C,161");
sa.push("HwC,3T,141,5C,60");
sa.push("HwD,3T,141,6C,43");
sa.push("IeA,4T,102,4C,110");
sa.push("IeB,4T,102,4C,110");
sa.push("KaB,4T,102,6C,43");
sa.push("KaC,4T,102,6C,43");
sa.push("LoC,3T,141,6C,43");
sa.push("LoE,3T,141,6C,43");
sa.push("MeB,4T,102,3C,161");
sa.push("MeC,4T,102,1C,378");
sa.push("NaD,3T,141,4C,110");
sa.push("NaE,3T,141,6C,43");
sa.push("PaF,3T,141,6C,43");
sa.push("PcD2,4T,102,6C,43");
sa.push("TaD,3T,141,5C,60");
sa.push("TaE,3T,141,6C,43");
sa.push("W,6T,68,6C,43"); //Wet/water
sa.push("We,6T,68,6C,43");
sa.push("WkD,4T,102,6C,43");
sa.push("WkF,4T,102,6C,43");
sa.push("WoB,3T,141,6C,43");
sa.push("Powerline,7T,9,7C,9");

export interface iTaxRate {
   soilType: string;
   timberCode: string;
   timberValue: number;
   cropCode: string;
   cropValue: number;
}

export interface iTaxRateValue {
   code: string;
   value: number;
}

const rates: iTaxRate[] = [];

for (const txt of sa) {
   const sa2: string[] = txt.split(",");
   rates.push({ soilType: sa2[0], timberCode: sa2[1], timberValue: parseInt(sa2[2], 10), cropCode: sa2[3], cropValue: parseInt(sa2[4], 10) });
}

//Get tax rate values.
export function getTaxRate(agUseType: string, soilType: string): iTaxRateValue {
   for (const rate of rates) {
      if (rate.soilType.toLowerCase() === soilType.toLowerCase()) {
         if (agUseType === "Timber") {
            return { code: rate.timberCode, value: rate.timberValue };
         } else {
            return { code: rate.cropCode, value: rate.cropValue };
         }
      }
   }
   return null;
}
